import * as R from "ramda";
import memoizee from "memoizee";

import { getItemsArray } from "redux/hor/module/selectors";

export const getItems = memoizee(
  R.compose(
    R.map((item) => ({
      label: item.custom_название,
      value: item.key,
      localization: item.custom_элементы_локализации,
      currency: item.custom_символ_валюты,
    })),
    getItemsArray
  ),
  { max: 1 }
);

export const getCountryCurrency = memoizee(
  (countries, country, defaultCurrency = "₽") =>
    R.compose(
      R.propOr(defaultCurrency, "currency"),
      R.find(R.propEq("value", country)),
      getItems
    )(countries),
  { max: 10 }
);